import { FundraiserSettingsAccordionEnum } from 'src/shared/models/enums/fundraiserSettingsAccordion.enum';

interface FundraiserSettingsAccordionContentInterface {
  id: FundraiserSettingsAccordionEnum;
  label: string;
}

const fundraiserSettingsAccordionContent: FundraiserSettingsAccordionContentInterface[] = [
  {
    id: FundraiserSettingsAccordionEnum.NewDonationNotice,
    label: 'fundraiser:fundraiserSettingsTitles.newDonationNotice',
  },
  {
    id: FundraiserSettingsAccordionEnum.PostPaymentText,
    label: 'fundraiser:fundraiserSettingsTitles.postPaymentText',
  },
  {
    id: FundraiserSettingsAccordionEnum.ReceiptToDonor,
    label: 'fundraiser:fundraiserSettingsTitles.receiptToDonor',
  },
  {
    id: FundraiserSettingsAccordionEnum.GiftLetterToDonor,
    label: 'fundraiser:fundraiserSettingsTitles.giftLetterToDonor',
  },
];

export const GetFilteredAccordionContent = (excludeIds?: FundraiserSettingsAccordionEnum[]): FundraiserSettingsAccordionContentInterface[] => {
  if (!excludeIds || excludeIds.length === 0) {
    return fundraiserSettingsAccordionContent;
  }

  return fundraiserSettingsAccordionContent.filter((item) => !excludeIds.includes(item.id));
};
